















import Vue from "vue";

export default Vue.extend({
  name: "WmDrawer",
  props: {
    mask: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 600,
    },
    extraStyle: {
      type: Object,
      default: () => {
        return { paddingBottom: "80px" };
      },
    },
    container:{
      type:String,
      default:'black-main'
    }
  },
  data() {
    return {
      maxHeight: "600px",
      marginTop: "0",
    };
  },
  watch: {
    visible: {
      handler() {
        this.getHeight();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getHeight() {
      const co = document.getElementById(this.container);
      if (co) {
        // console.log(co.offsetTop)
        this.maxHeight = co.offsetHeight + "px";
        // this.marginTop = (co.offsetTop + 'px')
      }
    },
    onClose() {
      this.$emit("close");
    },
  },
});
